import { PaymentDetailsForm } from "./PaymentsDetailsForm";
import { ModifyAndSelectedPlan } from "./ModifyAndSelectedPlan";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo, clearUserInfo } from "../../../../store/auth/authSlice";
import { useGetUserQuery } from "../../../../store/auth/usersApiSlice";
import { useEffect, useState } from "react";

export const PaymentDetails = () => {
  const location = useLocation();
  const [paymentBreakdown, setPaymentBreakdown] = useState();
  const { planDetails } = location.state;
  const stateData = location.state;
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { data, refetch, isSuccess, isError, error } = useGetUserQuery(token);
  const [isSessionExpired, setSessionExpired] = useState(false);
 
  useEffect(() => {
    if (isError) {
      if (error?.data?.code == 'token_not_valid') {
        setSessionExpired(true);
      }
    }
    if (isSuccess) {
      dispatch(setUserInfo({ ...data }));
      localStorage.removeItem("slug");
      localStorage.removeItem("lastVisited");
    }
  }, [data, dispatch, isSuccess, isError]);

  useEffect(() => {
    if (data) {
      refetch();
    }
  }, [refetch, data]);

  return (
    <>
      <div className="bg-[#ebf0f3] py-10 text-left flex justify-center items-center">
        <div className=" max-w-[1280px] mx-auto">
          <div className="p-4 sm:flex flex-row-reverse gap-4">

            <ModifyAndSelectedPlan planDetails={planDetails} paymentBreakdown={paymentBreakdown} />
            <PaymentDetailsForm planDetails={planDetails} setPaymentBreakdown={setPaymentBreakdown} paymentBreakdown={paymentBreakdown}  />
          </div>
        </div>
      </div>
    </>
  );
};
